import React, { useState, useEffect } from 'react';

// React Bootstrap
import { Form } from 'react-bootstrap'

// Material UI
import Button from '@mui/material/Button';
import RadioGroup from '@mui/material/RadioGroup'; 
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import RadioButton from './RadioButton';

const IGC = ({ handleChange, values, voltarPagina, proximaPagina, data }) => {

    const ind_1 = 0;
    const ind_2 = 1;
    const ind_3 = 2;
    const ind_4 = 3;
    
    const [investimentoError, setInvestimentoError] = useState(false);
    const [capacitaçãoError, setCapacitaçãoErrorError] = useState(false);
    const [incentivoError, setIncentivoError] = useState(false);
    const [parceriaError, setParceriaError] = useState(false);

    const submitForm = (e) => {
        e.preventDefault();

        setInvestimentoError(false);
        setCapacitaçãoErrorError(false);
        setIncentivoError(false);
        setParceriaError(false);

        if (!values[data.questoes[ind_1].pergunta]) {
            setInvestimentoError(true);
        }

        if (!values[data.questoes[ind_2].pergunta]) {
            setCapacitaçãoErrorError(true);
        }
        
        if (!values[data.questoes[ind_3].pergunta]) {
            setIncentivoError(true);
        }
        
        if (!values[data.questoes[ind_4].pergunta]) {
            setParceriaError(true);
        }

        if (values[data.questoes[ind_1].pergunta] 
                && values[data.questoes[ind_2].pergunta] 
                && values[data.questoes[ind_3].pergunta]
                && values[data.questoes[ind_4].pergunta]) {
                    proximaPagina();
                }
    };

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <Form noValidate onSubmit={submitForm}>
            <h3>
                {data.dimensao}
            </h3>
 
            <Box className='mt-5'>
                <FormControl error={investimentoError}>
                    <FormLabel className='mb-2'>
                        {data.questoes[ind_1].pergunta}
                    </FormLabel>
                    <RadioGroup
                        onChange={handleChange}
                        required >
                        <RadioButton
                            value={1}
                            name={data.questoes[ind_1].pergunta}
                            label={data.questoes[ind_1].alternativas[0]}
                            checked={values[data.questoes[ind_1].pergunta] === 1}
                        />
                        <RadioButton
                            value={2}
                            name={data.questoes[ind_1].pergunta}
                            label={data.questoes[ind_1].alternativas[1]}
                            checked={values[data.questoes[ind_1].pergunta] === 2}
                        />
                        <RadioButton
                            value={3}
                            name={data.questoes[ind_1].pergunta}
                            label={data.questoes[ind_1].alternativas[2]}
                            checked={values[data.questoes[ind_1].pergunta] === 3}
                        />
                        <RadioButton
                            value={4}
                            name={data.questoes[ind_1].pergunta}
                            label={data.questoes[ind_1].alternativas[3]}
                            checked={values[data.questoes[ind_1].pergunta] === 4}
                        />
                        <RadioButton
                            value={5}
                            name={data.questoes[ind_1].pergunta} 
                            label={data.questoes[ind_1].alternativas[4]}
                            checked={values[data.questoes[ind_1].pergunta] === 5}
                        />
                    </RadioGroup>

                    {investimentoError ? (
                        <FormHelperText>
                            Selecione uma opção
                        </FormHelperText>) : null}
                </FormControl>
            </Box>

            <Box className='mt-5'>
                <FormControl error={capacitaçãoError}>
                    <FormLabel className='mb-2'>
                        {data.questoes[ind_2].pergunta}
                    </FormLabel>
                    <RadioGroup
                        onChange={handleChange}
                        required >
                        <RadioButton
                            value={1}
                            name={data.questoes[ind_2].pergunta} 
                            label={data.questoes[ind_2].alternativas[0]}
                            checked={values[data.questoes[ind_2].pergunta] === 1}
                        />
                        <RadioButton
                            value={2}
                            name={data.questoes[ind_2].pergunta} 
                            label={data.questoes[ind_2].alternativas[1]}
                            checked={values[data.questoes[ind_2].pergunta] === 2}
                        />
                        <RadioButton
                            value={3}
                            name={data.questoes[ind_2].pergunta} 
                            label={data.questoes[ind_2].alternativas[2]}
                            checked={values[data.questoes[ind_2].pergunta] === 3}
                        />
                        <RadioButton
                            value={4}
                            name={data.questoes[ind_2].pergunta} 
                            label={data.questoes[ind_2].alternativas[3]}
                            checked={values[data.questoes[ind_2].pergunta] === 4}
                        />
                        <RadioButton
                            value={5}
                            name={data.questoes[ind_2].pergunta} 
                            label={data.questoes[ind_2].alternativas[4]}
                            checked={values[data.questoes[ind_2].pergunta] === 5}
                        />
                    </RadioGroup>

                    {capacitaçãoError ? (
                        <FormHelperText>
                            Selecione uma opção
                        </FormHelperText>) : null}
                </FormControl>
            </Box>

            <Box className='mt-5'>
                <FormControl error={incentivoError}>
                    <FormLabel className='mb-2'>
                        {data.questoes[ind_3].pergunta}
                    </FormLabel>
                    <RadioGroup
                        onChange={handleChange}
                        required >
                        <RadioButton
                            value={1}
                            name={data.questoes[ind_3].pergunta} 
                            label={data.questoes[ind_3].alternativas[0]}
                            checked={values[data.questoes[ind_3].pergunta] === 1}
                        />
                        <RadioButton
                            value={2}
                            name={data.questoes[ind_3].pergunta} 
                            label={data.questoes[ind_3].alternativas[1]}
                            checked={values[data.questoes[ind_3].pergunta] === 2}
                        />
                        <RadioButton
                            value={3}
                            name={data.questoes[ind_3].pergunta} 
                            label={data.questoes[ind_3].alternativas[2]}
                            checked={values[data.questoes[ind_3].pergunta] === 3}
                        />
                        <RadioButton
                            value={4}
                            name={data.questoes[ind_3].pergunta} 
                            label={data.questoes[ind_3].alternativas[3]}
                            checked={values[data.questoes[ind_3].pergunta] === 4}
                        />
                        <RadioButton
                            value={5}
                            name={data.questoes[ind_3].pergunta} 
                            label={data.questoes[ind_3].alternativas[4]}
                            checked={values[data.questoes[ind_3].pergunta] === 5}
                        />
                    </RadioGroup>

                    {incentivoError ? (
                        <FormHelperText>
                            Selecione uma opção
                        </FormHelperText>) : null}
                </FormControl>
            </Box>
            
            <Box className='mt-5'>
                <FormControl error={parceriaError}>
                    <FormLabel className='mb-2'>
                        {data.questoes[ind_4].pergunta}
                    </FormLabel>
                    <RadioGroup
                        onChange={handleChange}
                        required >
                        <RadioButton
                            value={1}
                            name={data.questoes[ind_4].pergunta} 
                            label={data.questoes[ind_4].alternativas[0]}
                            checked={values[data.questoes[ind_4].pergunta] === 1}
                        />
                        <RadioButton
                            value={2}
                            name={data.questoes[ind_4].pergunta} 
                            label={data.questoes[ind_4].alternativas[1]}
                            checked={values[data.questoes[ind_4].pergunta] === 2}
                        />
                        <RadioButton
                            value={3}
                            name={data.questoes[ind_4].pergunta} 
                            label={data.questoes[ind_4].alternativas[2]}
                            checked={values[data.questoes[ind_4].pergunta] === 3}
                        />
                        <RadioButton
                            value={4}
                            name={data.questoes[ind_4].pergunta} 
                            label={data.questoes[ind_4].alternativas[3]}
                            checked={values[data.questoes[ind_4].pergunta] === 4}
                        />
                        <RadioButton
                            value={5}
                            name={data.questoes[ind_4].pergunta} 
                            label={data.questoes[ind_4].alternativas[4]}
                            checked={values[data.questoes[ind_4].pergunta] === 5}
                        />
                    </RadioGroup>

                    {parceriaError ? (
                        <FormHelperText>
                            Selecione uma opção
                        </FormHelperText>) : null}
                </FormControl>
            </Box>

            <div className="d-flex justify-content-center mt-5">
                <Button
                    className='col-4'
                    onClick={voltarPagina}
                    color="primary"
                    size="lg"
                    variant="outlined"
                    startIcon={<ArrowBackIosIcon />}
                >
                    Voltar
                </Button>

                <span className='col-1'></span>
                
                <Button
                    className='col-4'
                    type="submit"
                    color="primary"
                    size="lg"
                    variant="outlined"
                    endIcon={<ArrowForwardIosIcon />}
                >
                    Próximo
                </Button>
            </div>
        </Form>
    );
};

export default IGC;